var _rect, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheese(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 1200 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#7E24E2",
    width: 1200,
    height: 800
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 600,
    y1: 25,
    x2: 600,
    y2: 777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7E24E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#493396"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 650,
    y1: 25,
    x2: 650,
    y2: 777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7925db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e329d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 700,
    y1: 25,
    x2: 700,
    y2: 777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7427d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5330a4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 750,
    y1: 25,
    x2: 750,
    y2: 777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7028cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#572fab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 800,
    y1: 25,
    x2: 800,
    y2: 777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b29c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c2eb2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 850,
    y1: 25,
    x2: 850,
    y2: 777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#662bbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612cb9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 900,
    y1: 25,
    x2: 900,
    y2: 777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#612cb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662bbf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 950,
    y1: 25,
    x2: 950,
    y2: 777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c2eb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b29c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 1000,
    y1: 25,
    x2: 1000,
    y2: 777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#572fab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7028cd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 1050,
    y1: 25,
    x2: 1050,
    y2: 777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5330a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7427d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 1100,
    y1: 25,
    x2: 1100,
    y2: 777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e329d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7925db"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 1150,
    y1: 25,
    x2: 1150,
    y2: 777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#493396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E24E2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.52
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#a)",
    width: 1200,
    height: 800
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#b)",
    x: 100,
    width: 1100,
    height: 800
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#c)",
    x: 200,
    width: 1000,
    height: 800
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#d)",
    x: 300,
    width: 900,
    height: 800
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#e)",
    x: 400,
    width: 800,
    height: 800
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#f)",
    x: 500,
    width: 700,
    height: 800
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#g)",
    x: 600,
    width: 600,
    height: 800
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#h)",
    x: 700,
    width: 500,
    height: 800
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#i)",
    x: 800,
    width: 400,
    height: 800
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#j)",
    x: 900,
    width: 300,
    height: 800
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#k)",
    x: 1000,
    width: 200,
    height: 800
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#l)",
    x: 1100,
    width: 100,
    height: 800
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheese);
export default __webpack_public_path__ + "static/media/cheese.87938df3f1fd23f70524d39173e80810.svg";
export { ForwardRef as ReactComponent };